import { observable, computed, reaction, autorun, observe, set } from 'mobx'
import GroupInfoStore from './GroupInfoStore'
class ManagementViewStore {
  @observable noGroupFlag = false
  @observable checkedAdminId = null
  @observable searchListMap = new Map()
  @observable searchFlag = false
  @observable searchId = null
  @observable searchContent = ''
  @observable previousSearchName = null
  @observable currentSearchName = ''
  // 删除团队成员
  @observable deleteMember = false
  @observable deleteID = null
  //是否显示注册辖区
  @observable registerAreaIntegrity = 0
  @observable registerArea = false
  //注册清运小组
  @observable registerCleanerIntegrity = 0
  @observable registerCleaner = false
  //是否显示编辑辖区
  //判断是点击删除cleaner还是admin
  @observable isEditArea = true
  @observable editAreaIntegrity = 0
  @observable editAreaAdminId = null
  @observable editArea = false
  @observable editAreaName = ''
  @observable editAreaUser = ''
  @observable editAreaAdmin = ''
  @observable editAreaPhone = ''
  @observable editCleanerNum = ''
  @observable editCarNum = ''
  //是否显示编辑小组
  @observable editCleanerIntegrity = 0
  @observable editCleanerId = null
  @observable editCleaner = false
  @observable editCleanerBelong = ''
  @observable editCleanerAreaName = ''
  @observable editCleanerUser = ''
  @observable editCleanerBoss = ''
  @observable editCleanerPhone = ''
  @observable editCleanerCar = ''
}
const store = new ManagementViewStore()

export default store



// WEBPACK FOOTER //
// ./src/store/ManagementViewStore.js